module.exports = __webpack_public_path__ + "static/media/sala-comedor.d780766c.jpg";